import { render } from "./PasswordResetInitiateScreen.vue?vue&type=template&id=64e09878&scoped=true"
import script from "./PasswordResetInitiateScreen.vue?vue&type=script&lang=js"
export * from "./PasswordResetInitiateScreen.vue?vue&type=script&lang=js"

import "./PasswordResetInitiateScreen.vue?vue&type=style&index=0&id=64e09878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e09878"]])

export default __exports__